"use client";

import { cn } from "@/lib/utils";
import {
  IconFileDescription,
  IconMicrophone,
  IconRoute,
  IconFileText,
  IconChartBar,
  IconUsers,
  IconSearch,
  IconList,
} from "@tabler/icons-react";
import { useTranslations } from "next-intl";

export const GridFeatures = () => {
  const t = useTranslations("grid");

  const features = [
    {
      title: t("g1_title"),
      description: t("g1_desc"),
      icon: <IconFileDescription className="h-6 w-6" />,
    },
    {
      title: t("g2_title"),
      description: t("g2_desc"),
      icon: <IconMicrophone className="h-6 w-6" />,
    },
    {
      title: t("g3_title"),
      description: t("g3_desc"),
      icon: <IconRoute className="h-6 w-6" />,
    },
    {
      title: t("g4_title"),
      description: t("g4_desc"),
      icon: <IconFileText className="h-6 w-6" />,
    },
    {
      title: t("g5_title"),
      description: t("g5_desc"),
      icon: <IconChartBar className="h-6 w-6" />,
    },
    {
      title: t("g6_title"),
      description: t("g6_desc"),
      icon: <IconUsers className="h-6 w-6" />,
    },
    {
      title: t("g7_title"),
      description: t("g7_desc"),
      icon: <IconSearch className="h-6 w-6" />,
    },
    {
      title: t("g8_title"),
      description: t("g8_desc"),
      icon: <IconList className="h-6 w-6" />,
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 relative z-10 py-10">
      {features.map((feature, index) => (
        <Feature key={feature.title} {...feature} index={index} />
      ))}
    </div>
  );
};

const Feature = ({
  title,
  description,
  icon,
  index,
}: {
  title: string;
  description: string;
  icon: React.ReactNode;
  index: number;
}) => {
  return (
    <div
      className={cn(
        "flex flex-col lg:border-r py-10 relative group dark:border-neutral-800",
        (index === 0 || index === 4) && "lg:border-l dark:border-neutral-800",
        index < 4 && "lg:border-b dark:border-neutral-800"
      )}
    >
      {index < 4 && (
        <div className="opacity-0 group-hover:opacity-100 transition duration-200 group absolute inset-0 h-full w-full bg-gradient-to-t from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
      )}
      {index >= 4 && (
        <div className="opacity-0 group-hover:opacity-100 transition duration-200 group absolute inset-0 h-full w-full bg-gradient-to-b from-neutral-100 dark:from-neutral-800 to-transparent pointer-events-none" />
      )}
      <div className="mb-4 relative z-10 px-10 text-neutral-600 dark:text-neutral-400">
        {icon}
      </div>
      <div className="text-lg font-bold mb-2 relative z-10 px-10">
        <div className="absolute left-0 inset-y-0 h-6 w-1 rounded-tr-full rounded-br-full bg-neutral-300 dark:bg-neutral-700 group-hover:bg-blue-500 transition duration-200" />
        <span className="group-hover:translate-x-2 transition duration-200 inline-block">
          {title}
        </span>
      </div>
      <p className="text-sm text-muted dark:text-muted-dark max-w-xs mx-auto relative z-10 px-10">
        {description}
      </p>
    </div>
  );
};
